/* eslint eqeqeq: "off" */
import React, { useEffect, useState } from "react";
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  SettingFilled,
  DownOutlined,
  PlusOutlined,
  RightOutlined,
  SettingOutlined,
  CrownOutlined,
  SafetyCertificateOutlined,
  BankOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import PropTypes from "prop-types";
import { useHistory, withRouter } from "react-router-dom";
import {
  Avatar,
  Button,
  Layout,
  Divider,
  Popover,
  theme,
  Tooltip,
  Typography,
  Col,
} from "antd";
import { Link } from "react-router-dom";
import "./index.css";
import { isEmpty, isUndefined } from "lodash";
import { items, profileDetails, settingsList } from "./data";
import useMedia from "use-media-antd-query";
import { useDispatch, useSelector } from "react-redux";
import api from "../../helpers";
import toast, { Toaster } from "react-hot-toast";
import { loadOrganizationList } from "../../store/organisation/actions";
import Spinners from "../spinner/Spinner";
const { Header, Content, Footer, Sider } = Layout;

const LayoutMain = (props) => {
  const dispatch = useDispatch();
  const [collapsed, setCollapsed] = useState(false);
  const [subMenuSelected, setSubMenuSelected] = useState("");
  const [settingsMenu, setSettingsMenu] = useState("");
  const [globalMenu, setGlobalMenu] = useState("");
  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const media = useMedia();

  const { organization_list = [] } = useSelector((state) => state.Organisation);

  //values from login response
  const userName = localStorage.getItem("authData");

  const userNameDetails = JSON.parse(userName);
  const userAdmin = !isEmpty(userNameDetails)
    ? userNameDetails.user.isAdmin
    : "";
  const organizationId =
    !isEmpty(userNameDetails) &&
    userNameDetails.user &&
    userNameDetails.user.organizations.length > 0
      ? userNameDetails.user.organizations[0].organizationId
      : "";
  const userId = !isEmpty(userNameDetails) ? userNameDetails.user._id : "";

  const usersList = { userId: userId, organizationId: organizationId };

  const userInfoDetails =
    !isEmpty(organization_list) &&
    organization_list !== undefined &&
    organization_list.organizationName
      ? organization_list.organizationName
      : !isEmpty(userNameDetails) &&
        userNameDetails.user &&
        userNameDetails.user.organizations.length > 0
      ? userNameDetails.user.organizations[0].organizationName
      : "";
  const userMobileNo =
    !isEmpty(organization_list) &&
    organization_list !== undefined &&
    organization_list.organizationPhone
      ? organization_list.organizationPhone
      : !isEmpty(userNameDetails)
      ? userNameDetails.user.mobileNo
      : "";

  const userNameAvatar = !isEmpty(userInfoDetails)
    ? userInfoDetails.slice(0, 1)
    : "";

  const profileName = userInfoDetails ? userInfoDetails : "";
  const profileNameAvatar = !isEmpty(profileName)
    ? profileName.slice(0, 1)
    : "";

  //values from login response end

  //settings screen
  const [settingsScreen, setSettingsScreen] = useState(false);
  // const [subMenuPath, setSubMenuPath] = useState("");
  // const [selected, setSelected] = useState(false);

  const settingsMode =
    props && props.location && !isEmpty(props.location.state)
      ? props.location.state.settingsMode
      : false;
  const menuPath = props && props.location ? props.location.pathname : "";

  useEffect(() => {
    if (menuPath === "/settings/user-roles") {
      setSettingsScreen(true);
      setSettingsMenu("Manage Users");
    }
  }, [menuPath]);

  useEffect(() => {
    if (media === "md" || media === "sm" || media === "xs") {
      setCollapsed(true);
    } else {
      setCollapsed(false);
    }
  }, [media]);

  const history = useHistory();

  //window height/width
  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );
  const [downloadLoading, setDownloadLoading] = useState(false);

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    dispatch(loadOrganizationList(usersList));
    api
      .post("/org/getorganization", usersList)
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        const errorMsg =
          error &&
          error.response &&
          error.response.data &&
          error.response.data.isTokenExpired;
        const errorData =
          error &&
          error.response &&
          error.response.data &&
          error.response.data.message;
        if (errorMsg === true) {
          toast.error(
            errorData || "Your session has expired. Please log in again"
          );
          setTimeout(() => {
            history.push("/login");
            localStorage.setItem("accountDetails", "");
            localStorage.setItem("userDetails", "");
            localStorage.setItem("authToken", "");
            localStorage.setItem("user", "");
            localStorage.setItem("authData", "");
          }, 2000);
        }
        return Promise.reject(error);
      });

    setDownloadLoading(true);
    setTimeout(() => {
      setDownloadLoading(false);
    }, 2000);

    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <React.Fragment>
      <Col md={24} sm={24} lg={24} xl={24} xxl={24}>
        {(settingsMode === true || settingsScreen === true) &&
        downloadLoading == true ? (
          <Spinners collapsed={collapsed} />
        ) : (
          ""
        )}
      </Col>
      <Layout
        style={{
          padding: "6px",
        }}
      >
        <Sider
          collapsible
          width={240}
          trigger={null}
          theme={
            settingsMode === true || settingsScreen === true ? "light" : "dark"
          }
          // onScroll={true}
          collapsedWidth={75}
          collapsed={collapsed}
          style={{
            borderRadius: "10px",
            marginRight: "4px",
            overflow: "hidden",
            height: "100%",
            position: "fixed",
            boxShadow: "#dbdbdb 0px 3px 6px 3px",
            opacity: 20,
            transition: collapsed
              ? "all 800ms ease-in-out"
              : "all 800ms ease-in-out",
            // scrollBehavior: "unset",
            border:
              settingsMode === true || settingsScreen === true
                ? ""
                : "2px solid #001529",
          }}
          // onCollapse={(value) => setCollapsed(value)}
        >
          <>
            <div
              style={{
                padding: "5px",
                height:
                  settingsMode === true || settingsScreen === true
                    ? "14%"
                    : windowDimensions.height > 700 &&
                      windowDimensions.height < 800
                    ? "16%"
                    : windowDimensions.height > 800 &&
                      windowDimensions.height < 900
                    ? "14%"
                    : windowDimensions.height > 900 &&
                      windowDimensions.height < 1000
                    ? "13%"
                    : windowDimensions.height >= 1000 &&
                      windowDimensions.height < 1100
                    ? "13%"
                    : windowDimensions.height >= 1100
                    ? "11%"
                    : "18%",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div
                className={
                  settingsMode === true || settingsScreen === true
                    ? "sidebar-settings-header flex"
                    : "flex sidebar-header"
                }
              >
                <div className="flex">
                  <p
                    className={
                      !collapsed
                        ? "profile-avatar capitalize"
                        : "capitalize mobile-profile-avatar"
                    }
                  >
                    {!isEmpty(userInfoDetails) && userNameAvatar
                      ? userNameAvatar
                      : !isEmpty(profileName) && profileNameAvatar
                      ? profileNameAvatar
                      : ""}
                  </p>
                  {!collapsed ? (
                    <div className="mx-1 mt-[-4px]">
                      <h1
                        className={
                          settingsMode === true || settingsScreen === true
                            ? "uppercase ml-2 text-[black] font-semibold text-[12px]"
                            : "uppercase ml-2 text-[12px] font-semibold"
                        }
                      >
                        {!isEmpty(userInfoDetails)
                          ? userInfoDetails
                          : !isEmpty(profileName)
                          ? profileName
                          : ""}
                      </h1>
                      <h1
                        className={
                          settingsMode === true || settingsScreen === true
                            ? "text-[12px] text-[black]"
                            : !isEmpty(userInfoDetails) &&
                              userInfoDetails.length < 10
                            ? "ml-[15px] text-[12px] text-[#ababab]"
                            : "text-[12px] text-[#ababab]"
                        }
                      >
                        {!isEmpty(userInfoDetails) ? userMobileNo : ""}
                      </h1>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                {settingsMode === true || settingsScreen === true ? (
                  <Tooltip placement="right" title={""}></Tooltip>
                ) : (
                  <>
                    {!collapsed ? (
                      <Tooltip placement="right" title={"S Phoenix"}>
                        <div
                          onClick={() => setSettingsScreen(true)}
                          className={"profile-settings"}
                        >
                          <Link
                            to={{
                              pathname: "/settings/manage-business",
                              state: {
                                settingsMode: true,
                              },
                            }}
                          >
                            <SettingFilled width={30} height={30} />
                          </Link>
                        </div>
                      </Tooltip>
                    ) : (
                      ""
                    )}
                  </>
                )}
              </div>
              {settingsMode === true || settingsScreen === true ? (
                <div
                  className={
                    !collapsed
                      ? "dashboard-routing"
                      : "mobile-dashboard-routing"
                  }
                >
                  <Link
                    to={{
                      pathname: "/dashboard",
                    }}
                    onClick={() => setSettingsScreen(false)}
                  >
                    <ArrowLeftOutlined className="mr-2" />{" "}
                    {!collapsed ? "Back to Dashboard" : ""}
                  </Link>
                </div>
              ) : (
                <div className="flex mt-2">
                  <Button
                    className={
                      !collapsed ? "invoice-btn" : "mobile-invoice-btn"
                    }
                    onClick={() => history.push("/create-sales-invoice")}
                  >
                    <p
                      className={
                        !collapsed
                          ? "sidebar-header-list text-[14px] text-[600]"
                          : "sidebar-header-list ml-1 text-[14px] text-[600]"
                      }
                    >
                      <PlusOutlined />
                    </p>{" "}
                    {!collapsed ? "Create Sales Invoice" : ""}
                  </Button>
                  {!collapsed ? (
                    <DownOutlined className="cursor-pointer bg-[white] p-[9px] text-[black] rounded-r-xl" />
                  ) : (
                    ""
                  )}
                </div>
              )}
            </div>
            {settingsMode === true || settingsScreen === true ? (
              <div
                className={
                  windowDimensions.height >= 1000 &&
                  windowDimensions.height <= 1100
                    ? "mt-[-50px] scroll-settings-layout ml-[7px] mr-[7px] h-[69%]"
                    : windowDimensions.height > 1100 &&
                      windowDimensions.height < 1350
                    ? "mt-[-50px] scroll-settings-layout ml-[7px] mr-[7px] h-[63%]"
                    : windowDimensions.height >= 1350
                    ? "mt-[-80px] scroll-settings-layout ml-[7px] mr-[7px] h-[55%]"
                    : "mt-5 scroll-settings-layout ml-[7px] mr-[7px] h-[71%]"
                }
              >
                {settingsList.map((data, index) => {
                  return (
                    <div className="mt-1 mb-3 pl-2.5 pr-2.5">
                      <Link
                        to={{
                          pathname: data.label.props.to.pathname,
                          state: {
                            settingsMode: true,
                          },
                        }}
                        onClick={() => {
                          setSettingsMenu(data.key);
                        }}
                        key={index}
                        className={
                          settingsMenu === data.key ||
                          menuPath === data.label.props.to.pathname
                            ? "flex text-[#ffffff] sidebar-header-list font-medium bg-[#4399e9] p-2 rounded-2xl"
                            : "flex text-[#000000] sidebar-header-list font-medium hover:bg-[#ebebeb] p-2 rounded-2xl"
                        }
                      >
                        <p
                          className={
                            collapsed === true
                              ? "ml-1 hover:text-[#ffffff]"
                              : "mr-2 hover:text-[#ffffff]"
                          }
                        >
                          {data.icon}
                        </p>
                        {collapsed === true ? (
                          ""
                        ) : (
                          <h1 className="hover:text-[#ffffff">{data.label}</h1>
                        )}
                      </Link>
                    </div>
                  );
                })}

                {/* <Menu
                  theme="light"
                  // defaultSelectedKeys={["dashboard"]}
                  mode="inline"
                  triggerSubMenuAction="click"
                  rootClassName="leading-relaxed"
                  selectable={true}
                  activeKey={menuPath}
                  onClick={() => setSettingsScreen(true)}
                  className={
                    "text-start border-none sidebar-header-list mt-[10px] text-[#171772] font-medium"
                  }
                  items={settingsList}
                /> */}
              </div>
            ) : (
              <div
                className={
                  windowDimensions.height > 700 && windowDimensions.height < 800
                    ? "mt-2 scroll-layout h-[66%]"
                    : windowDimensions.height > 800 &&
                      windowDimensions.height < 900
                    ? "mt-2 scroll-layout h-[68%]"
                    : windowDimensions.height > 900 &&
                      windowDimensions.height < 1000
                    ? "scroll-layout h-[69%]"
                    : windowDimensions.height >= 1000 &&
                      windowDimensions.height < 1100
                    ? "mt-2 scroll-layout h-[69%]"
                    : windowDimensions.height > 1100
                    ? "mt-2 scroll-layout h-[60%]"
                    : "mt-2 scroll-layout h-[64%]"
                }
              >
                <div
                  className={
                    !collapsed ? "feature-pricing" : "mobile-feature-pricing"
                  }
                >
                  <a href="/dashboard">
                    <div className="flex justify-between text-[black] text-[11px]">
                      <div className="flex">
                        <CrownOutlined
                          className={!collapsed ? "" : "text-[16px]"}
                        />
                        {!collapsed ? (
                          <div className="ml-2 mt-0.5">Buy Premium Plan </div>
                        ) : (
                          ""
                        )}
                      </div>
                      {!collapsed ? (
                        <div className="ml-5 bg-[#d01717] text-[#ffffff] rounded-lg pr-[8px] pl-[8px] pt-[1px] pb-[1px] text-[700]">
                          4 Days Left
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </a>
                </div>

                {items.length > 0 &&
                  items.map((data, index) => {
                    const subMenuPath =
                      data &&
                      data.children &&
                      data.children.length > 0 &&
                      menuPath
                        ? data.children.find(
                            (subMenu) => subMenu.pathname == menuPath
                          )
                        : "";
                    const subMenuPathName = subMenuPath && subMenuPath.pathname;

                    console.log(subMenuPathName, "subMenuPathName");
                    console.log(menuPath, "menuPath");

                    return (
                      <div key={index} className="mt-2 mb-2 pl-2.5 pr-2.5">
                        <Link
                          onClick={() => {
                            if (
                              data.label === "General" ||
                              data.label === "Accounting Solutions"
                            ) {
                              setGlobalMenu("");
                            }
                            if (data.label) {
                              setGlobalMenu(data.label);
                            } else {
                              setGlobalMenu(data.label);
                            }
                            if (
                              subMenuSelected === data.label &&
                              data.children &&
                              data.children.length > 0
                            ) {
                              setSubMenuSelected("");
                            } else {
                              setSubMenuSelected(data.label);
                            }
                          }}
                          to={{
                            pathname: data.pathname,
                          }}
                          className={
                            // globalMenu === data.label ||
                            menuPath == data.pathname
                              ? "flex justify-between text-[#ffffff] sidebar-header-list font-medium bg-[#4399e9bf] p-2 rounded-2xl"
                              : data.label === "General" ||
                                data.label === "Accounting Solutions"
                              ? "flex justify-between text-[lightgray] sidebar-header-list font-medium p-2 rounded-2xl"
                              : "flex justify-between text-[lightgray] sidebar-header-list font-medium hover:bg-[#7b6f6fb0] p-2 rounded-2xl"
                          }
                        >
                          {data.label === "General" ||
                          data.label === "Accounting Solutions" ? (
                            <div className="mb-[-6px]">
                              <h1
                                className={
                                  collapsed
                                    ? "ml-[-16px] uppercase text-[10px] text-[#ffffff]"
                                    : "ml-[-3px] uppercase text-[10px] text-[#ffffff]"
                                }
                              >
                                {data.label}
                              </h1>
                            </div>
                          ) : (
                            <div className="flex">
                              <p className="mr-2">{data.icon}</p>
                              {collapsed ? (
                                ""
                              ) : (
                                <h1 className="">{data.label}</h1>
                              )}
                            </div>
                          )}
                          {(subMenuPathName !== undefined &&
                            menuPath === subMenuPathName &&
                            data.children &&
                            data.children.length > 0) ||
                          (subMenuSelected === data.label &&
                            data.children &&
                            data.children.length > 0) ? (
                            //   ||
                            // (data.children &&
                            //   data.children.length > 0 &&
                            //   subMenuPath &&
                            //   subMenuPath.pathname == menuPath)
                            <DownOutlined
                              className="mt-1"
                              onClick={() => {
                                setSubMenuSelected("");
                                // setSubMenuPath("");
                              }}
                            />
                          ) : data.children && data.children.length > 0 ? (
                            <RightOutlined
                              className="mt-1"
                              onClick={() => {
                                setSubMenuSelected(data.label);
                                // setSubMenuPath(subMenuPathName);
                              }}
                            />
                          ) : (
                            ""
                          )}{" "}
                        </Link>
                        <div className="ml-2 mt-2 bg-[#181717] rounded-lg">
                          {(subMenuPathName !== undefined &&
                            menuPath === subMenuPathName) ||
                          (subMenuSelected == data.label &&
                            data.children &&
                            data.children.length > 0)
                            ? // ||
                              // (menuPath == data.pathname &&
                              //   data.children &&
                              //   data.children.length > 0) ||
                              // (data.children &&
                              //   data.children.length > 0 &&
                              //   subMenuPath &&
                              //   subMenuPath.pathname == menuPath)
                              data.children.map((subMenu, index) => {
                                return (
                                  <div
                                    onClick={() => {
                                      setGlobalMenu(subMenu.label);
                                    }}
                                    key={index}
                                  >
                                    <Link
                                      to={{
                                        pathname: subMenu.pathname,
                                      }}
                                      className={
                                        globalMenu === subMenu.label ||
                                        menuPath === subMenu.pathname
                                          ? "flex text-[10px] text-[#ffffff] sidebar-header-list font-medium bg-[#4399e9bf] p-1 pl-2 pb-2 pt-2 mb-2 rounded-2xl"
                                          : "flex text-[10px] text-[lightgray] sidebar-header-list font-medium hover:bg-[#7b6f6fb0] p-1 pl-2 pb-2 pt-2 mb-2 rounded-2xl"
                                      }
                                    >
                                      <p className="text-[12px] mr-2 mt-1 hover:text-[#ffffff]">
                                        {subMenu.icon}
                                      </p>
                                      {collapsed ? (
                                        ""
                                      ) : (
                                        <h1 className="text-[12px] hover:text-[#ffffff">
                                          {subMenu.label}
                                        </h1>
                                      )}
                                    </Link>
                                  </div>
                                );
                              })
                            : ""}
                        </div>
                      </div>
                    );
                  })}

                {/* <Menu
                  theme="dark"
                  // defaultSelectedKeys={["dashboard"]}
                  mode="inline"
                  selectable={true}
                  // defaultSelectedKeys={["dashboard"]}
                  // triggerSubMenuAction='click'
                  // activeKey={menuPath}
                  // selectedKeys={getAssociatedPaths}
                  triggerSubMenuAction="click"
                  // inlineCollapsed={true}
                  subMenuOpenDelay={1}
                  
                  className="text-start sidebar-header-list mt-[10px] rounded-lg"
                  items={items}
                /> */}
              </div>
            )}
            {settingsMode === true || settingsScreen === true ? (
              <div className="sidebar-settings-open-menu h-[15%]">
                <Divider
                  style={{
                    borderWidth: "0.2px",
                    marginBottom: "10px",
                  }}
                />
                {!collapsed ? (
                  <div className="flex justify-center ml-2">
                    <Typography className="text-[#15213a] font-medium text-[12px]">
                      <SafetyCertificateOutlined className="mx-1" /> 100% secure
                    </Typography>
                  </div>
                ) : (
                  ""
                )}
              </div>
            ) : (
              <div
                className={
                  // windowDimensions.height >= 1000 &&
                  // windowDimensions.height < 1100
                  //   ? "sidebar-settings-main h-[20%]"
                  //   : windowDimensions.height >= 1100
                  //   ? "sidebar-settings-main h-[15%]"
                  //   :
                  "sidebar-settings-main h-[15%]"
                }
              >
                <div
                  onClick={() => setSettingsScreen(true)}
                  className={
                    isUndefined(userAdmin)
                      ? "pointer-events-none opacity-25 sidebar-settings mt-5"
                      : "sidebar-settings mt-5"
                  }
                >
                  <Link
                    to={{
                      pathname: "/settings/manage-business",
                      state: {
                        settingsMode: true,
                      },
                    }}
                  >
                    <p className="ml-3 flex text-[14px] text-[600]">
                      <SettingOutlined className="text-[16px]" />
                      {!collapsed ? (
                        <p
                          className="ml-2"
                          style={{
                            fontFamily: "Poppins",
                            fontSize: "13px",
                          }}
                        >
                          Settings
                        </p>
                      ) : (
                        ""
                      )}
                    </p>
                  </Link>
                </div>
                {!collapsed ? (
                  <div
                    style={{
                      fontFamily: "Poppins",
                      fontSize: "13px",
                    }}
                    className="flex space-evenly mt-3 ml-4"
                  >
                    <Typography className="text-start text-[#a3a3a3] text-[10px]">
                      <SafetyCertificateOutlined className="mx-1" /> 100% secure
                    </Typography>
                    <Typography className="mx-4 text-start text-[#a3a3a3] text-[10px]">
                      <BankOutlined className="mx-1" />
                      ISO 27001 Certified
                    </Typography>
                  </div>
                ) : (
                  ""
                )}
              </div>
            )}
          </>
        </Sider>
        <Layout
          className={
            collapsed ? "pl-[85px]" : settingsMode ? "pl-[250px]" : "pl-[245px]"
          }
          style={{
            transition: collapsed
              ? "all 800ms ease-in-out"
              : "all 800ms ease-in-out",
          }}
        >
          <Header
            style={{
              padding: 0,
              background: colorBgContainer,
              textAlign: "start",
              display: "flex",
              flexDirection: "row",
              borderRadius:
                settingsMode === true || settingsScreen === true ? "8px" : "",
              justifyContent: "space-between",
            }}
          >
            <Button
              type="text"
              icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              onClick={() => setCollapsed(!collapsed)}
              style={{
                fontSize: "16px",
                width: 64,
                height: 64,
              }}
            />
            <Popover
              trigger={"click"}
              placement="bottom"
              content={profileDetails}
              className="w-[200px] h-[40px] mt-4 mr-6 border border-gray-100 rounded-md"
            >
              <div className="flex justify-between ">
                <div className="flex pl-2 pr-2">
                  <Avatar
                    style={{
                      backgroundColor: "#8400ff",
                      marginTop: "8px",
                      textTransform: "capitalize",
                    }}
                    size={"small"}
                  >
                    {!isEmpty(userInfoDetails) && userNameAvatar
                      ? userNameAvatar
                      : !isEmpty(profileName) && profileNameAvatar
                      ? profileNameAvatar
                      : ""}
                  </Avatar>{" "}
                  <h1 className="uppercase mt-[-12px] text-[12px] ml-1 text-[black] font-semibold">
                    {!isEmpty(userInfoDetails)
                      ? userInfoDetails
                      : !isEmpty(profileName)
                      ? profileName
                      : ""}
                  </h1>
                </div>
                <DownOutlined className="cursor-pointer pl-2 pr-2" />
              </div>
            </Popover>
          </Header>
          <Content
            style={{
              borderRadius: "8px",
            }}
          >
            <div
              style={{
                padding: "8px 2px",
                textAlign: "start",
                // height: "400px",
              }}
            >
              {props.children}
            </div>
          </Content>
          {menuPath === "/reports/stock-details-report" ||
          menuPath === "/reports/barcode-items-report" ||
          menuPath === "/reports/item-quantity-report" ||
          menuPath === "/reports/payment-in-report" ||
          menuPath === "/reports/payment-out-report" ||
          menuPath === "/reports/sales-report" ||
          menuPath === "/reports/sales-return-report" ? (
            ""
          ) : (
            <Footer
              style={{
                textAlign: "center",
                position: "sticky",
                top: "4px",
                bottom: 0,
                display: "flex",
                height: "50px",
                background: "#f1f1f1",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Typography
                style={{
                  fontFamily: "Poppins",
                }}
                className="text-[12px]"
              >
                MBook ©{new Date().getFullYear()}
              </Typography>
              <Typography
                style={{
                  fontFamily: "Poppins",
                }}
                className="text-[12px]"
              >
                Created by Mequals Technologies
              </Typography>
            </Footer>
          )}
        </Layout>
      </Layout>
      <Toaster containerClassName="text-[12px]" />
    </React.Fragment>
  );
};

LayoutMain.propTypes = {
  children: PropTypes.object,
  location: PropTypes.object,
};
export default withRouter(LayoutMain);
